const styles = {
  draft: "border-border text-muted-foreground",
  sent: "border-foreground text-foreground",
  paid: "border-[#16A34A] text-[#16A34A]",
  accepted: "border-[#16A34A] text-[#16A34A]",
  void: "border-destructive text-destructive",
};

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-${status}`} className={`inline-block border px-2 py-0.5 text-[10px] tracking-[0.2em] uppercase font-semibold ${styles[status] || styles.draft}`}>
      {status}
    </span>
  );
}
